export type ModuleTourTab = 'chat' | 'reports' | 'subscriptions' | 'archive';

export interface ModuleTourStep {
  id: string;
  anchor: string | null;
  titleKey: string;
  textKey: string;
  tab: ModuleTourTab;
  constructorMode: boolean;
  /** `sections` only when the constructor has data; `empty` only when it does not. */
  when?: 'sections' | 'empty';
  offerGuide?: boolean;
}

export const MODULE_TOUR_STEPS: ModuleTourStep[] = [
  {
    id: 'tabs',
    anchor: 'module-tabs',
    titleKey: 'reporting_analytics.tour_tabs_title',
    textKey: 'reporting_analytics.tour_tabs_text',
    tab: 'chat',
    constructorMode: false
  },
  {
    id: 'sessions',
    anchor: 'saved-queries',
    titleKey: 'reporting_analytics.tour_sessions_title',
    textKey: 'reporting_analytics.tour_sessions_text',
    tab: 'chat',
    constructorMode: false
  },
  {
    id: 'chat',
    anchor: 'chat-panel',
    titleKey: 'reporting_analytics.tour_chat_title',
    textKey: 'reporting_analytics.tour_chat_text',
    tab: 'chat',
    constructorMode: false,
    offerGuide: true
  },
  {
    id: 'results',
    anchor: 'results-panel',
    titleKey: 'reporting_analytics.tour_results_title',
    textKey: 'reporting_analytics.tour_results_text',
    tab: 'chat',
    constructorMode: false
  },
  {
    id: 'jobs',
    anchor: 'job-queue',
    titleKey: 'reporting_analytics.tour_jobs_title',
    textKey: 'reporting_analytics.tour_jobs_text',
    tab: 'chat',
    constructorMode: false
  },
  {
    id: 'mode',
    anchor: 'mode-switch',
    titleKey: 'reporting_analytics.tour_mode_title',
    textKey: 'reporting_analytics.tour_mode_text',
    tab: 'chat',
    constructorMode: false
  },
  {
    id: 'constructor',
    anchor: 'constructor-filled',
    titleKey: 'reporting_analytics.tour_constructor_title',
    textKey: 'reporting_analytics.tour_constructor_text',
    tab: 'chat',
    constructorMode: true,
    when: 'sections'
  },
  {
    id: 'constructor-empty',
    anchor: 'constructor-empty',
    titleKey: 'reporting_analytics.tour_constructor_empty_title',
    textKey: 'reporting_analytics.tour_constructor_empty_text',
    tab: 'chat',
    constructorMode: true,
    when: 'empty'
  },
  {
    id: 'reports',
    anchor: 'reports-catalog',
    titleKey: 'reporting_analytics.tour_reports_title',
    textKey: 'reporting_analytics.tour_reports_text',
    tab: 'reports',
    constructorMode: false
  },
  {
    id: 'files',
    anchor: 'reports-output',
    titleKey: 'reporting_analytics.tour_files_title',
    textKey: 'reporting_analytics.tour_files_text',
    tab: 'reports',
    constructorMode: false
  },
  {
    id: 'subscriptions',
    anchor: 'subscriptions-panel',
    titleKey: 'reporting_analytics.tour_subscriptions_title',
    textKey: 'reporting_analytics.tour_subscriptions_text',
    tab: 'subscriptions',
    constructorMode: false
  },
  {
    id: 'archive',
    anchor: 'archive-panel',
    titleKey: 'reporting_analytics.tour_archive_title',
    textKey: 'reporting_analytics.tour_archive_text',
    tab: 'archive',
    constructorMode: false
  },
  {
    id: 'done',
    anchor: null,
    titleKey: 'reporting_analytics.tour_done_title',
    textKey: 'reporting_analytics.tour_done_text',
    tab: 'chat',
    constructorMode: false
  }
];
